import type { GetHistoryEntry } from '@repo/schema/history'

export const flattenHistoryPages = <T extends { data: readonly GetHistoryEntry[] }>(
  pages: readonly T[] | undefined,
) => {
  const entries: GetHistoryEntry[] = []
  const entryIds = new Set<number>()

  for (const page of pages ?? []) {
    for (const entry of page.data) {
      if (!entryIds.has(entry.id)) {
        entryIds.add(entry.id)
        entries.push(entry)
      }
    }
  }

  return entries
}
